import { createAction, props } from '@ngrx/store';
import { IIdValuePair } from 'src/app/core/interfaces/common/common/id-value-pair.interface';
import { Address } from 'src/app/core/models/common/address.model';
import { CustomerSearch } from 'src/app/core/models/customer-portfolio/customerSearch.model';

export const CUSTOMER_NAME_AND_REF_NUMBER =
  '[CustomerPortfolio] CustomerDetails';
export const CUSTOMER_NAME_AND_ID = '[CustomerPortfolio] IdAndName';
export const FEDERAL_OR_AGENCY = '[CustomerPortfolio] FederalOrAgency';
export const IS_HEADQUARTER_ADDRESS =
  '[CustomerPortfolio] IsHeadquarterAddress';
export const HEADQUARTER_ADDRESS = '[CustomerPortfolio] HeadquarterAddress';
export const INVOCIE_AMOUNT_PER_MONTH =
  '[CustomerPortfolio] InvoiceAmountPerMonth';
export const BILLING_ADDRESS = '[CustomerPortfolio] BillingAddress';
export const INVOICE_TERM = '[CustomerPortfolio] InvoiceTerm';
export const CLIENT_CUSTOMER_ID = '[CustomerPortfolio] ClientCustomerId';
export const BILLING_COUNTRY = '[CustomerPortfolio] BillingCountry';
export const ALL = '[CustomerPortfolio] All';
export const PHYSICAL_ADDRESS = '[CustomerPortfolio] PhysicalAddressAction';
export const PHYSICAL_COUNTRY = '[CustomerPortfolio] PhysicalCountry';
export const HEADQUARTER_COUNTRY = '[CustomerPortfolio] HeadquarterCountry';
export const INVOCIE_PER_MONTH = '[CustomerPortfolio] InvoicePerMonth';
export const FEDERAL_DOCUMENT_NUMBER =
  '[CustomerPortfolio] federalDocumentNumber';
export const CLEAR = '[CustomerPortfolio] Clear';
export const CUSTOMER_SEARCH = '[CustomerPortfolio] CustomerSearch';

export const CustomerNameAndRefNumberAction = createAction(
  CUSTOMER_NAME_AND_REF_NUMBER,
  props<{
    CustomerRefNumber: string;
    customerName: string;
  }>()
);

export const CustomerNameAndIdAction = createAction(
  CUSTOMER_NAME_AND_ID,
  props<{
    clientCustomerId: string;
    customerName: string;
  }>()
);

export const BillingCountryAction = createAction(
  BILLING_COUNTRY,
  props<{
    billingCountry: string;
  }>()
);

export const HeadquarterCountryAction = createAction(
  HEADQUARTER_COUNTRY,
  props<{
    headquarterCountry: string;
  }>()
);

export const FederalOrAgencyAction = createAction(
  FEDERAL_OR_AGENCY,
  props<{
    isFederal: boolean;
  }>()
);

export const IsHeadquarterAddressAction = createAction(
  IS_HEADQUARTER_ADDRESS,
  props<{
    isHeadquarterAddress: boolean;
  }>()
);

export const InvoiceAmountPerMonthAction = createAction(
  INVOCIE_AMOUNT_PER_MONTH,
  props<{
    monthlyInvoiceAmount: string;
  }>()
);

export const ClientCustomerIdAction = createAction(
  CLIENT_CUSTOMER_ID,
  props<{
    clientCustomerId: number;
  }>()
);

export const FederalDocumentNumberAction = createAction(
  FEDERAL_DOCUMENT_NUMBER,
  props<{
    federalDocumentNumber: number;
  }>()
);

export const InvoiceTermAction = createAction(
  INVOICE_TERM,
  props<{
    invoiceTerm: IIdValuePair;
  }>()
);

export const PhysicalAddressAction = createAction(
  PHYSICAL_ADDRESS,
  props<{
    physicalAddress: Address;
  }>()
);

export const PhysicalCountryAction = createAction(
  PHYSICAL_COUNTRY,
  props<{
    physicalCountry: string;
  }>()
);

export const HeadquarterAddressAction = createAction(
  HEADQUARTER_ADDRESS,
  props<{
    headquarterAddress: Address;
  }>()
);

export const BillingAddressAction = createAction(
  BILLING_ADDRESS,
  props<{
    billingAddress: Address;
  }>()
);
export const CustomerSearchAction = createAction(
  CUSTOMER_SEARCH,
  props<{
    customerSearch: CustomerSearch;
  }>()
);
export const AllAction = createAction(
  ALL,
  props<{
    clientCustomerId: number;
    clientId: number;
    CustomerRefNumber: string;
    customerName: string;
    isFederal: boolean;
    billingAddress: Address;
    headquarterAddress: Address;
    isHeadquarterAddress: boolean;
    customerType: IIdValuePair;
    monthlyInvoiceAmount: string;
    invoiceTerm: IIdValuePair;
    billingCountry: string;
    physicalAddress: Address;
    physicalCountry: string;
    federalDocumentNumber: number;
    headquarterCountry: string;
  }>()
);

// Record<string, never> just means 'empty object'
export const ClearCustomerAction = createAction(
  CLEAR,
  props<Record<string, never>>
);

export type All =
  | ReturnType<typeof CustomerNameAndRefNumberAction>
  | ReturnType<typeof CustomerNameAndIdAction>
  | ReturnType<typeof FederalOrAgencyAction>
  | ReturnType<typeof BillingAddressAction>
  | ReturnType<typeof CustomerSearchAction>
  | ReturnType<typeof HeadquarterAddressAction>
  | ReturnType<typeof InvoiceTermAction>
  | ReturnType<typeof InvoiceAmountPerMonthAction>
  | ReturnType<typeof IsHeadquarterAddressAction>
  | ReturnType<typeof ClientCustomerIdAction>
  | ReturnType<typeof BillingCountryAction>
  | ReturnType<typeof HeadquarterCountryAction>
  | ReturnType<typeof PhysicalAddressAction>
  | ReturnType<typeof PhysicalCountryAction>
  | ReturnType<typeof FederalDocumentNumberAction>
  | ReturnType<typeof AllAction>
  | ReturnType<typeof ClearCustomerAction>;
